<!--
	作者：masonchen
	时间：2017-04-10
	描述：车辆轨迹页面_左侧车辆列表模块
-->
<template>
	<div class="tab-vertical-left track_list tab-vertical" :class="{'opac': isPlaying}">
		<div class="tab-title"> 
			<span>轨迹回放队列</span> 
			<em @click="hidePanel" :class="[rollUp?'downArrow':'upArrow']" data-toggle="tracetip" data-placement="bottom" title="折叠"></em> 
		</div>
		<div class="tab-body">
			<div class="tab-content" id="myWeek">
				<div class="tab-bar">
					<div class="track_top_btn trackList_top_btn">
						<i><a class="ico_01" @click="checkAll">全选</a></i> 
						<i><a class="ico_02" @click="reCheckAll">反选</a></i> 
						<i class="dropdown">
							<a class="ico_04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">菜单</a>
							<ul class="dropdown_menu list_menu">
								<li class="list_group_item" @click="exportSel">选中项导出</li>
								<li class="list_group_item" @click="exportAll">全部导出</li>
								<li class="list_group_item" @click="deleteVehicle">选中项删除</li>		
							</ul>
						</i>
					<!--	<i><a class="ico_03" @click="deleteVehicle">删除</a></i>-->
					</div>
					<div class="track_bottom_btn">
						<i @click="clearAllList"><a class="ico_01">清空队列</a></i> 
						<i>
							<input type="checkbox" v-model="reDrawMode">
							<span>清空重绘</span>
						</i>
					</div>
					<div class="tab-row" v-loading="loadinglist" element-loading-text="加载中">
						<div class="track_value">
							<ul v-for="(item, index) in traceList" class="track_value_ul">
								<vehicle-item-location v-if="item.showType == '1'" :data="item" :checked="item.isChecked"></vehicle-item-location>
								<vehicle-item-alarm v-if="item.showType == '2'" :data="item" :checked="item.isChecked"></vehicle-item-alarm>
								<vehicle-item-trace v-if="item.showType == '4' || item.showType == '3'" :data="item" :checked="item.isChecked"></vehicle-item-trace>
							</ul>
							<laypage ref="laypg" :pages="pagesTotal" v-on:changePage="cb" :groups="pagesTotal > 3 ? 3 : pagesTotal" :first="first" :last="last" :prev="prev" :next="next" class="laypage"></laypage>	
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VehicleItemLocation from './list/VehicleItemLocation'
	import VehicleItemAlarm from './list/VehicleItemAlarm'
	import VehicleItemTrace from './list/VehicleItemTrace'
	import Laypage from 'components/common/vueLaypage/Laypage'
	import {mapState} from 'vuex'
	export default{
		components: {
			VehicleItemLocation,
			VehicleItemAlarm,
			VehicleItemTrace,
			Laypage
		},
		data() {
			return {
				reDrawMode:true,
				rollUp:false,
				traceList:[],
				pagesTotal:0, //总页数
		        first:false, //不显示首页
		        last:false,	//不显示尾页
		        prev: '上一页',
		        next: '下一页',
		        pageNum:1
			}
		},
		computed: {
			...mapState({
				checkedArr:state => state.vehicle.checkedArr,
				totalTraceList:state=>state.vehicle.totalTraceList,
				traceListInfo:state=>state.vehicle.traceListInfo,//从轨迹队列接口获取的队列列表对象
				loadinglist:state => state.vehicle.loadinglist,
				isPlaying:state => state.vehicle.isPlaying,
				openFrom:state => state.vehicle.openFrom
			})
		},
		watch:{
			checkedArr:{
				handler:function(val){
					console.log(val)
				},
				deep:true
			},
			traceListInfo:{
				handler:function(val){
					if(val==null){
						this.traceList = []
						this.pagesTotal = 0
						
					}else{
//						console.log(val)
						this.traceList = val.list
						this.pagesTotal = val.pages;
						this.$refs.laypg.setPage(val.pageNum)
					}
				},
				deep:true
			},
			reDrawMode:function(val){//清空重绘模式
				this.$store.dispatch('clearBeforeDraw',val)
			}
		},
		beforeMount(){ 
			if(this.openFrom===0){//只有通过点击菜单打开才调用该方法
				this.$store.dispatch('getTraces',1)
			}
			this.$nextTick(function(){
				$('[data-toggle="tracetip"]').tooltip()
			})
		}, 
		updated(){
			this.$nextTick(function(){
				$('[data-toggle="tracetip"]').tooltip()
			})
		},
		destroyed(){
			$('[data-toggle="tracetip"]').tooltip('hide')
		},
		methods: {
			// 隐藏主面板
			hidePanel(){
				$(".track_list .tab-body").toggle(200);
				this.rollUp = !this.rollUp;
			},
			// 点击全选
			checkAll(){
				this.$store.dispatch('setCheckbox')
			},
			// 点击反选
			reCheckAll(){
				this.$store.dispatch('reCheckbox')
			},
			exportSel(){//选中项导出
				let arr = this.checkedArr
				if(arr.length != 0){//'/trace/traces/export/devices'
					this.$store.dispatch('exportTrack',true)
					this.$store.dispatch('getTaskNum',arr.length)
					this.$store.dispatch('openMainTip','已为您加入后台任务')
					this.$http.post(process.env.API_ROOT + '/trace/traces/export/devices',arr)
					.then(res=>{
						this.$store.dispatch('getTaskNum',0) 
						this.$store.dispatch('openMainTip','后台任务执行完毕，可以点击后台任务查看')
					},res=>{
						this.$store.dispatch('openMainTip',res.body.message)
					})
					.catch(res=>{
						this.$store.dispatch('openMainTip','请求异常')
					})
				}else{
					const obj = {
						tipCnt:'请先选中将要导出的轨迹队列项目',
						showBtn:false
					}
					this.$store.dispatch('showModal',obj)
				}
			},
			exportAll(){//全部导出'/trace/traces/export'
				this.$store.dispatch('getTaskNum',this.traceList.length) 
				this.$store.dispatch('exportTrack',true)
				this.$store.dispatch('openMainTip','已为您加入后台任务')
				this.$http.post(process.env.API_ROOT + '/trace/traces/export')
					.then(res=>{
						this.$store.dispatch('getTaskNum',0) 
						this.$store.dispatch('openMainTip','后台任务执行完毕，可以点击后台任务查看')
					},res=>{
						this.$store.dispatch('openMainTip',res.body.message)
					})
					.catch(res=>{
						this.$store.dispatch('openMainTip','请求异常')
					})
			},
			// 点击删除
			deleteVehicle(){
				let arr = this.checkedArr;
				let obj = {
					arr:this.checkedArr,
					page:this.pageNum
				}
				if(arr.length != 0){
					this.$store.dispatch('deleteTraceList',obj).then(()=>{
						this.$store.dispatch('getTraces',1)
					})
				}else{
					const obj = {
						tipCnt:'请先选中将要删除的轨迹队列项目',
						showBtn:false
					}
					this.$store.dispatch('showModal',obj)
				}
			},
			//清空队列--锁定除外
			clearAllList(){
				if(!this.traceList.length){
					return;
				}
				//弹出确认框
				const obj = {
					tipCnt:'您将要清空轨迹队列中的所有项目（被锁定的项目除外），您确定要继续吗？',
					showBtn:true
				}
				this.$store.dispatch('showModal',obj)
			},
			//分页相关--
			cb(page){
				this.pageNum = page
				this.$store.dispatch('getTraces',page)
			}
		}
	}
</script>
<style scoped lang="scss">
.trackList_top_btn{
	overflow:visible;
	.list_menu{
		right:0;
		left:auto;
		top:calc(100% + 5px);
	}
}
.opac {
	opacity: 0.7;
}
</style>


// WEBPACK FOOTER //
// VehicleList.vue?1ca923bc